/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Lab } from '../../models/lab';

export interface LabControllerGetLabList$Params {
}

export function labControllerGetLabList(http: HttpClient, rootUrl: string, params?: LabControllerGetLabList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Lab>>> {
  const rb = new RequestBuilder(rootUrl, labControllerGetLabList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Lab>>;
    })
  );
}

labControllerGetLabList.PATH = '/lab/list';
